<template>
  <div>
    <v-row>
      <v-col>
        <AddActivatedService @input="addNewService" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-tabs
          v-if="uniqueTypeServices.length"
          v-model="activeTab"
          class="ml-1 my-2"
        >
          <v-tab
            v-for="(serviceType, index) in uniqueTypeServices"
            :key="`service-type-${index}`"
          >
            {{ serviceType.title }}
          </v-tab>

          <v-tabs-items
            v-if="uniqueTypeServices.length > 0"
            v-model="activeTab"
          >
            <v-tab-item
              v-for="(serviceType, index) in uniqueTypeServices"
              :key="`service-item-${index}`"
            >
              <v-card
                text
                flat
              >
                <ClientService
                  v-for="(service, index) in getServicesByType(serviceType)"
                  :key="`client-service-${index}`"
                  :item="service"
                  @remove="remove(service.service.id)"
                  @change="enableToSave"
                />
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ClientService from "./ClientService.vue";
import { writeOffWayTypes, getUniqueArrByKey } from "@/helpers";

import AddActivatedService from "./AddActivatedService.vue";

export default {
  components: {
    ClientService,
    AddActivatedService,
  },
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    activeTab: "",
  }),
  computed: {
    uniqueTypeServices() {
      const services = this.value
        .map((as) => {
          return {
            id: as.type.id,
            title: as.type.title,
          };
        });
      return getUniqueArrByKey(services, "id");
    },
  },
  methods: {
    getServicesByType(service) {
      return this.value
        .filter((as) => as.type.id === service.id)
        .sort(
          (a, b) => new Date(b.payedTo) - new Date(a.payedTo)
        );
    },
    remove(id) {
      const services = this.value.filter(({ service }) => service.id !== id);
      this.updateValue(services);
    },
    enableToSave() {
      this.$emit("enableToSave");
    },
    addNewService(newService) {
      const services = [...this.value, {
        service: {
          title: newService.title,
          id: newService.id,
        },
        recurrence: newService.recurrence,
        type: {
          id: newService.type.id,
          title: newService.type.title,
        },
        startFrom: newService.startFrom,
        payedTo: newService.payedTo,
        stoppedFrom: null,
        price: newService.price,
        amount: newService.amount,
        quantity: newService.quantity,
        writeOffWay: writeOffWayTypes.INVOICE,
      }];

      this.setActiveTab(newService.type.id);
      this.updateValue(services);
    },
    setActiveTab(id) {
      this.activeTab = id;
    },
    updateValue(value) {
      this.$emit("input", value);
    },
  },
};
</script>
